import qs from 'qs';

export const generateBuyLink = (query = {}) => {
  return `${location.origin}/opc/buy?${qs.stringify(query)}`;
};

export const generatePlanCategory = (prefix, capacity) => {
  return `${prefix}${capacity ? capacity : ''}`;
};
